module.exports = __webpack_public_path__ + "img/spec-ar.da043cb9.jpg";